import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useListEmpresasQuery } from '../api/authApiSlice';
import { selectCurrentUser, selectTenantId, setTenantId } from '../authSlice';
import { apiSlice } from '../../../store/apiSlice';

export function TenantSwitcher() {
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const tenantId = useSelector(selectTenantId);
  const { data } = useListEmpresasQuery(undefined, {
    skip: user?.role !== 'SUPERADMIN',
  });

  const empresas = data?.data ?? [];

  useEffect(() => {
    if (user?.role !== 'SUPERADMIN' || tenantId != null || empresas.length === 0) return;
    dispatch(setTenantId(empresas[0].id));
  }, [user?.role, tenantId, empresas, dispatch]);

  if (user?.role !== 'SUPERADMIN') return null;

  return (
    <select
      className='hidden md:block text-sm border border-border rounded-md px-2 py-1.5 bg-background text-foreground max-w-[180px]'
      value={tenantId ?? ''}
      onChange={e => {
        dispatch(setTenantId(Number.parseInt(e.target.value, 10)));
        dispatch(
          apiSlice.util.invalidateTags([
            'NoragDomain',
            'NoragTemplate',
            'NoragJob',
            'NoragStats',
            'NoragFolder',
            'NoragBook',
          ])
        );
      }}
      aria-label='Seleccionar empresa'
    >
      {empresas.length === 0 ? (
        <option value=''>Sin empresas</option>
      ) : (
        empresas.map(empresa => (
          <option key={empresa.id} value={empresa.id}>
            {empresa.nombre}
          </option>
        ))
      )}
    </select>
  );
}
